import React, { Component } from 'react'
import IconButton from 'material-ui/IconButton'
import FlatButton from 'material-ui/FlatButton'
import Dropzone from 'react-dropzone'
import Arrow from 'material-ui/svg-icons/navigation/arrow-back'
import { FormattedMessage } from 'react-intl'
import config from '../../config/config'
import { getToken, isSentry } from '../../lib'

var canvas
export default class Image extends Component {
  constructor(props) {
    super(props)
    this.state = {
      captured: false,
      imagePreviewUrl: null,
      file: '',
      showButtons: false
    }
  }

  componentDidMount() {
    if (this.props.webcam) {
      this.startCapture()
    }
  }

  componentWillUnmount() {
    this.stopCapture()
  }

  getCapture = () => {
    const token = getToken()
    if (!this.state.captured) {
      var canvas = (window.canvas = document.getElementById('canvas2'))
      canvas.width = 334
      canvas.height = 334
      var video = document.getElementById('video')
      canvas
        .getContext('2d')
        .drawImage(video, 0, 0, canvas.width, canvas.height)
      this.setState({captured: true})
      this.stopCapture()
    } else {
      this.imageUploadCanvas()
      this.props.returnUserIfUserExists(token)
      this.props.handleRequestOpen()
      this.props.takePicture(false)
    }
  }

  clearCanvas = () => {
    var canvas = (window.canvas = document.getElementById('canvas2'))
    var context = canvas.getContext('2d')
    canvas.width = 0
    canvas.height = 0
    context.clearRect(0, 0, canvas.width, canvas.height)
  }

  async imageUploadCanvas() {
    var type = 'image/png;base64'
    canvas = document.getElementById('canvas2').toDataURL(type)
    var base64Data = canvas.split(',')[1]
    var data = window.atob(base64Data)
    var buff = new ArrayBuffer(data.length)
    var arr = new Uint8Array(buff)
    var blob, i, dataLen
    for (i = 0, dataLen = data.length; i < dataLen; i++) {
      arr[i] = data.charCodeAt(i)
    }
    blob = new Blob([arr], {type: type})
    var file = new File([blob], 'filename', {
      type: type,
      lastModified: Date.now()
    })
    var myHeaders = new Headers()
    myHeaders.append('Accept', 'application/json')
    data = new FormData()
    data.append('image', file, 'webrtc-camera.png')
    try {
      let response = await fetch(
        `${config.URI}/api/v1/image/${this.props.userid}`,
        {
          method: 'PUT',
          headers: myHeaders,
          credentials: 'include',
          cache: 'default',
          body: data
        }
      )
      let resposeJson = await response.json()
      console.log(resposeJson)
      return resposeJson
    } catch (error) {
      console.error(error)
      isSentry(error)
    }
  }

  handleSuccess = stream => {
    var video = document.getElementById('video')
    window.stream = stream // make stream available to browser console
    video.srcObject = stream
  }

  handleError = error => {
    isSentry(error)
    console.log('navigator.getUserMedia error: ', error)
  }

  startCapture = () => {
    var constraints = {
      audio: false,
      video: true
    }
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(this.handleSuccess)
      .catch(this.handleError)
  }

  stopCapture = () => {
    var stream = window.stream
    if (stream) {
      try {
        stream.stop()
      } catch (e) { isSentry(e) }
      try {
        var tracks = stream.getTracks()
        for (var i in tracks) {
          var mst = tracks[i]
          if (mst !== null && mst !== undefined) {
            console.log('stop')
            mst.stop()
          }
        }
      } catch (e) {
        console.error(e)
        isSentry(e)
      }
    }
  }

  handleClose = e => {
    this.stopCapture()
    this.props.takePicture(false)
  }

  handleCancel = e => {
    if (this.state.captured) {
      if (this.props.webcam) {
        this.clearCanvas()
        this.startCapture()
      }
      this.setState({captured: false, imagePreviewUrl: null})
    } else {
      this.stopCapture()
      this.props.takePicture(false)
    }
  }

  async imageUpload() {
    var myHeaders = new Headers()
    myHeaders.append('Accept', 'application/json')
    var data = new FormData()
    data.append('image', this.state.file, `upload.${this.state.file.name.split('.').pop()}`)
    try {
      let response = await fetch(
        `${config.URI}/api/v1/image/${this.props.userid}`,
        {
          method: 'PUT',
          headers: myHeaders,
          credentials: 'include',
          cache: 'default',
          body: data
        }
      )
      let resposeJson = await response.json()
      return resposeJson
    } catch (error) {
      console.error(error)
      isSentry(error)
    }
  }

  onImageDrop(files) {
    let reader = new FileReader()
    let file = files[0]
    reader.onloadend = output => {
      this.setState({
        captured: true,
        showButtons: true,
        file: file,
        imagePreviewUrl: reader.result
      })
    }
    reader.readAsDataURL(file)
  }

  handleUpload = () => {
    const token = getToken()
    this.imageUpload()
    this.props.returnUserIfUserExists(token)
    this.props.takePicture(false)
  }

  render() {
    let {captured} = this.state

    return (
      <div>
        <div className="flex justify-between items-center mb3">
          <IconButton
            onTouchTap={this.handleClose}
            iconStyle={{fill: '#6B7C93'}}
          >
            <Arrow/>
          </IconButton>
          <div style={{fontSize: 24, color: 'rgba(50, 50, 93, 0.7)'}}>
            {this.props.webcam ? (
              <FormattedMessage id="picture.take"/>
            ) : (
              <FormattedMessage id="picture.upload"/>
            )}{' '}
            <FormattedMessage id="picture.picture"/>
          </div>
          <div className="w2"/>
        </div>
        <div className="flex justify-center mb4">
          {this.props.webcam ? (
            <div>
              <canvas id="canvas2" className="br-100" height="0" width="0"/>
              {captured ? (
                ''
              ) : (
                <div
                  style={{height: 334, width: 334}}
                  className="overflow-hidden br-100 bg-black"
                >
                  <video
                    style={{width: 334, height: 334, objectFit: 'initial'}}
                    id="video"
                    autoPlay
                  />
                </div>
              )}
            </div>
          ) : this.state.imagePreviewUrl ? (
            <img
              style={{
                height: 334,
                width: 334,
                borderRadius: '100%'
              }}
              alt="img"
              src={this.state.imagePreviewUrl}
            />
          ) : (
            <Dropzone
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 334,
                height: 334,
                borderWidth: 2,
                borderColor: 'rgb(102, 102, 102)',
                borderStyle: 'dashed',
                borderRadius: '100%'
              }}
              multiple={false}
              accept="image/*"
              onDrop={files => this.onImageDrop(files)}
            >
              <p className="tc">
                <FormattedMessage id="picture.dropImage"/>
              </p>
            </Dropzone>
          )}
        </div>
        {(this.state.captured && this.state.showButtons) ||
        this.props.webcam ? (
          <div className="flex justify-center">
            <div className="w4">
              <FlatButton
                label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                labelStyle={{color: '#AFB8C4'}}
                fullWidth
                onTouchTap={this.handleCancel}
              />
            </div>
            <div className="ml2 w6">
              <FlatButton
                label={
                  this.state.captured ? (
                    <FormattedMessage id="picture.confirm"/>
                  ) : (
                    <FormattedMessage id="picture.takePic"/>
                  )
                }
                fullWidth
                hoverColor="#1e8257"
                backgroundColor="#29B87A"
                labelStyle={{color: '#FFFFFF'}}
                onTouchTap={
                  this.props.webcam ? this.getCapture : this.handleUpload
                }
              />
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Upload/Upload.js